import LocalizationInitializer from "./LocalizationInitializer";
import { getLocalizationService } from "./localizationService";

export class LocalizationHelper {
  /**
   * Returns the localized string for a given resource key.
   * Falls back to the provided default if not found.
   */
  static getLocalizedTitle(key: string, defaultValue: string): string {
    let service = getLocalizationService();
    let attempts = 0;
    while (!service && attempts < 3) {
       service = getLocalizationService();
      attempts++;
    }
    return service?.toLanguageString(key, defaultValue) ?? defaultValue;
  }
}